import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 12 2",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.25 1A.75.75 0 0 1 1 .25h10a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 1",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgComponent);
export const CheckboxDashIcon = ForwardRef;